{
	"submitTitle": "Избери материал",
	"summary": {
		"title": "Обобщение",
		"declarationTypeTitle": "Тип декларация",
		"projectReferenceTitle": "Референция на проект"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Изберете тип декларация",
			"customerProject": {
				"title": "Проект на клиента",
				"description": "Материалът е използван за външен проект. Сега трябва да предоставя декларация, която описва въглеродните редукции за моя клиент."
			},
			"internalProjectOrProduct": {
				"title": "Вътрешен проект / продукт",
				"description": "Материалът е използван за вътрешен проект или продукт. Трябва да създам декларация, за да заявя въглеродните редукции за нашите собствени операции."
			}
		},
		"addProjectReferenceSection": {
			"title": "Добавете референция на проект",
			"subTitle": "Трябва да присвоите въглеродните редукции към референция на проект, за който искате да създадете декларацията.",
			"projectReferencePlaceholder": "Референция на проект"
		},
		"selectProjectSection": {
			"title": "Изберете проект",
			"createNewProjectPlaceholder": "Създайте нов проект"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Типът декларация е задължителен",
		"projectReferenceRequired": "Референцията на проекта е задължителна",
		"fetchProjectsError": "Неуспешно извличане на предишни проекти"
	}
}
